import Chip from "@mui/material/Chip";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getKhattabat101CGeneralStore from "../../../stores/khattabat-stores/101c-stores/101c-general-store";
import getKhattabat101CStore from "../../../stores/khattabat-stores/101c-stores/index";

const KhattabatClientSubscriptionChip = withLiteObserverAndTheme<{
  userID: number;
}>((props) => {
  const { theme, userID } = props;
  const { colors } = theme;
  const isPaidClient =
    getKhattabat101CGeneralStore().conversationsClientType.get() === "PAID";

  const { labelKey, color } = getKhattabat101CStore(userID).getSubscriptionChip();

  return !isPaidClient ? null : (
    <Chip
      size="small"
      color={color}
      label={i18n.get(labelKey)}
      sx={
        labelKey === "TRIAL"
          ? { bgcolor: colors.all.yellow, color: "common.black" }
          : undefined
      }
    />
  );
});

export default KhattabatClientSubscriptionChip;
